import React from 'react';
import { MapPin, Mail, Phone } from "lucide-react";
import { UpdateHotelRequest } from '@repo/types';
import { SectionCard, DetailItem } from './HotelCommon';

interface ContactSectionProps {
    editForm: Partial<UpdateHotelRequest>;
    isEditMode: boolean;
    setEditForm: (form: Partial<UpdateHotelRequest>) => void;
}

export const ContactSection: React.FC<ContactSectionProps> = ({
    editForm,
    isEditMode,
    setEditForm
}) => {
    return (
        <SectionCard title="Contact & Location" icon={MapPin}>
            <DetailItem
                label="Email Address"
                value={editForm.Email || ""}
                isEdit={isEditMode}
                onChange={(val) => setEditForm({ ...editForm, Email: val })}
                icon={Mail}
            />
            <DetailItem
                label="Phone Number"
                value={editForm.Phone || ""}
                isEdit={isEditMode}
                onChange={(val) => setEditForm({ ...editForm, Phone: val })}
                icon={Phone}
            />
            <DetailItem
                label="Address"
                value={editForm.Address || ""}
                isEdit={isEditMode}
                onChange={(val) => setEditForm({ ...editForm, Address: val })}
                icon={MapPin}
            />
            <DetailItem
                label="City"
                value={editForm.City || ""}
                isEdit={isEditMode}
                onChange={(val) => setEditForm({ ...editForm, City: val })}
                icon={MapPin}
            />
            <DetailItem
                label="State"
                value={editForm.State || ""}
                isEdit={isEditMode}
                onChange={(val) => setEditForm({ ...editForm, State: val })}
                icon={MapPin}
            />
            <DetailItem
                label="Country"
                value={editForm.Country || ""}
                isEdit={isEditMode}
                onChange={(val) => setEditForm({ ...editForm, Country: val })}
                icon={MapPin}
            />
            <DetailItem
                label="Postal Code"
                value={String(editForm.PostalCode || "")}
                isEdit={isEditMode}
                onChange={(val) => setEditForm({ ...editForm, PostalCode: val })}
                icon={Mail}
            />
        </SectionCard>
    );
};
